var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObservationsByRegion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 143,
    viewBox: "0 0 236 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 236,
    height: 143,
    rx: 8,
    fill: "#F3F5F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 80,
    width: 24,
    height: 63,
    rx: 5,
    fill: "#009F88"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 68,
    width: 24,
    height: 75,
    rx: 5,
    fill: "#009F88"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 59,
    width: 24,
    height: 84,
    rx: 5,
    fill: "#009F88"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 59,
    width: 24,
    height: 84,
    rx: 5,
    fill: "#009F88"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 95,
    width: 24,
    height: 48,
    rx: 5,
    fill: "#009F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObservationsByRegion);
export default __webpack_public_path__ + "static/media/observationsByRegion.1db27f151ff309d40525749092ae795b.svg";
export { ForwardRef as ReactComponent };